/**
 * MİSAFİR MODU — giriş yapmadan ürünü GERÇEKTEN kullanma.
 *
 * ESKİ PLAN (kaldırıldı): ziyaretçi "önizleme" görüyordu; okuma boş dönüyor,
 * yazma engelleniyordu. Ürünü göremiyor, kabuğunu geziyordu.
 *
 * YENİ PLAN: sayfa açılır açılmaz sunucuda GEÇİCİ ama gerçek bir hesap doğar
 * (POST /api/guest/start). Misafirin kendi tenantı, kendi verisi ve ücretsiz
 * planın kredisi (50 AI kredi) olur. Kayıt olduğunda aynı tenant kalıcıya
 * döner (POST /api/guest/claim) — denerken kurduğu hiçbir şey kaybolmaz.
 *
 * Bu dosya yalnız KİMLİK sorusuna cevap verir: oturum var mı, misafir mi,
 * yoksa misafir oturumu nasıl açılır. İstek kesme/duvar mantığı YOK — misafir
 * artık gerçek bir kullanıcı; sınırları sunucu (kredi, plan) koyar.
 */

const TOKEN_KEY = "token";
const USER_KEY = "user";

const readStorageItem = (key) => {
  if (typeof window === "undefined") return null;
  try {
    const fromSession =
      typeof sessionStorage !== "undefined" ? sessionStorage.getItem(key) : null;
    if (fromSession !== null) return fromSession;
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

const parseStored = (raw) => {
  if (!raw) return null;
  try { return JSON.parse(raw); } catch (e) { return raw; }
};

/** Oturum (misafir de dahil) var mı. */
export const hasSession = () => !!readStorageItem(TOKEN_KEY);

/** Depodaki kullanıcı — misafir bayrağı burada taşınır. */
export const readStoredUser = () => {
  const parsed = parseStored(readStorageItem(USER_KEY));
  return parsed && typeof parsed === "object" ? parsed : null;
};

/**
 * MİSAFİR Mİ? Tek ölçüt: oturumdaki kullanıcının is_guest bayrağı.
 * Token'ın yokluğu artık misafirlik demek DEĞİL — misafirin de token'ı var.
 */
export const isGuest = (userLike) => {
  const user = userLike || readStoredUser();
  return !!(user && user.is_guest);
};

const persist = (token, user) => {
  try {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch (e) { /* özel sekmede depo kapalı olabilir; oturum bellekte sürer */ }
};

/* Aynı anda birden çok çağrı gelirse (StrictMode, iki bileşen) tek istek atılsın. */
let inFlight = null;

/* NEDEN AÇILAMADI — giriş ekranı bunu ziyaretçiye söylesin diye tutuluyor.
   Eskiden hata yutuluyordu: misafir oturumu açılamayınca ziyaretçi hiçbir
   açıklama olmadan /signin'e düşüyordu. En sık sebebi sunucunun IP başına
   saatlik misafir tavanı (429); aynı ağdaki telefon + bilgisayar aynı hakkı
   paylaşıyor, tavana çarpınca ekran sebepsiz giriş istiyordu. */
let lastFailure = null;

/** Son başarısız misafir denemesinin sebebi (yoksa null). */
export const getGuestStartFailure = () => lastFailure;
export const clearGuestStartFailure = () => { lastFailure = null; };

const describeFailure = (error) => {
  const response = error && error.response;
  const status = response ? response.status : 0;
  if (status === 429) {
    /* express-rate-limit standardHeaders: kalan süre saniye cinsinden gelir. */
    const reset = Number(response.headers && response.headers["ratelimit-reset"]);
    return {
      reason: "rate_limited",
      retryAfterMinutes: Number.isFinite(reset) && reset > 0 ? Math.ceil(reset / 60) : null,
    };
  }
  return { reason: status ? "server" : "network", status: status || null };
};

/**
 * Misafir oturumu aç. Zaten oturum varsa hiçbir şey yapmaz.
 * axios örneğini parametre alır ki bu dosya util/Api.js'e bağlanmasın
 * (Api.js de buradan okuyor; döngüsel bağımlılık olmasın).
 */
export const startGuestSession = (axiosInstance) => {
  if (hasSession()) return Promise.resolve(readStoredUser());
  if (inFlight) return inFlight;

  inFlight = axiosInstance
    .post("/api/guest/start", {
      timezone:
        (typeof Intl !== "undefined" &&
          Intl.DateTimeFormat().resolvedOptions().timeZone) ||
        "Europe/Istanbul",
    })
    .then(({ data }) => {
      if (data && data.error === 0 && data.token && data.user) {
        persist(data.token, data.user);
        lastFailure = null;
        return { token: data.token, user: data.user };
      }
      lastFailure = { reason: "server", status: null };
      return null;
    })
    .catch((error) => {
      lastFailure = describeFailure(error);
      return null;
    })
    .then((result) => {
      inFlight = null;
      return result;
    });

  return inFlight;
};
